import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {Community} from '../_types/communities';
import {LocalStorageService} from '../_services/local-storage.service';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrl: './privacy.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrivacyComponent {
    private readonly localStorageService: LocalStorageService = inject(LocalStorageService);


    get lastSelectedCommunity(): Community | null {
        return this.localStorageService.getItem<Community | null>('lastSelectedCommunity', null);
    }
}
